import Axios from 'axios'
import store from '../store'

const notificationalert = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  getAllAlerts() {
    return Axios.get(`api/v1/clients/${this.getClientId()}/notification-alerts`)
  },
  saveAlert(alert){
    if(alert.id){
      return Axios.put(`api/v1/clients/${this.getClientId()}/notification-alerts/${alert.id}`, alert,{
        ignoreGlobalCatch: true,
      })
    }

    return Axios.post(`api/v1/clients/${this.getClientId()}/notification-alerts`, alert,{
      ignoreGlobalCatch: true,
    })
  },
  removeAlert(id){
    return Axios.delete(`api/v1/clients/${this.getClientId()}/notification-alerts/${id}`)
  },
  getAlert(id){
    return Axios.get(`api/v1/clients/${this.getClientId()}/notification-alerts/${id}`)
  }
}

export default notificationalert
